var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.expreso)?_c('CardLayout',{staticClass:"mb-6",scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Expreso seleccionado")]},proxy:true}],null,false,2341604902)},[_c('div',[_c('b',[_vm._v(_vm._s(_vm.expreso.name))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }